import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/how-much-does-poshmark-take';

export default function Example() {
  return (
    <>
      <Head>
        <title>Poshmark Fees 2021- An Easy Guide to Poshmark's Fees</title>
        <meta name='description' content="Learn the ins and outs of Poshmark's seller fees and what the fees cover" />
        <link rel='canonical' href='https://tools.oneshop.com/blog/how-much-does-poshmark-take' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/how-much-does-poshmark-take' />
        <meta property='og:title' content="Poshmark Fees 2021- An Easy Guide to Poshmark's Fees" />
        <meta
          property='og:description'
          content="Learn the ins and outs of Poshmark's seller fees and what the fees cover"
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2021-10-21T00:00:00.000Z' />
        <meta property='article:modified_time' content='2021-10-21T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
